import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'

import StyledFixedHeightContainer from '../components/StyledFixedHeightContainer'

const CreditCCYTitle: FC<{ FormName: string }> = ({ FormName }) => {
  const title: string = useSelector((state) => formValueSelector(FormName)(state, 'creditCCY'))

  return <StyledFixedHeightContainer className="u-flexCenter">{title}</StyledFixedHeightContainer>
}

export default CreditCCYTitle
